import React from "react";
import { Button } from "antd";

export default function WebchatSaveButton({ hasUnsavedChanges = false, onSaveCallback = () => {} }) {

  return (
    
    <Button className="standard-button primary-dark-blue-button"  type={hasUnsavedChanges ? "primary" : "default"}
          onClick={onSaveCallback} disabled={!hasUnsavedChanges}>
      Apply
    </Button>
  );
}
